import { getConfigurator, isInstallationConfigurator } from '../selector';
import { BasePageModel } from 'models/BasePageModel';
import {
  IInstallationAddonProduct,
  LawnMowerAddonProduct,
  InstallationProducType,
  VvsInstallationProduct,
  InstallationAddonGroup,
  IZipFetchInstallationProduct,
  InstallationConfigurator
} from 'models/InstallationConfigurator';

export const hasSelectedInstallation = (configurator: InstallationConfigurator) => {
  return configurator.installation && configurator.installation.products.some(p => p.selected);
};
export const isInstallationSelected = (currentPage: BasePageModel) => {
  const configurator = getConfigurator(currentPage);

  if (!isInstallationConfigurator(configurator)) {
    return false;
  }
  return hasSelectedInstallation(configurator);
};

export const isLawnMowerProduct = (p: IInstallationAddonProduct): p is LawnMowerAddonProduct => {
  return p.type === InstallationProducType.Lawnmower;
};

export const isVvsProduct = (p: IInstallationAddonProduct): p is VvsInstallationProduct => {
  return p.type === InstallationProducType.Vvs;
};

export const getProducts = (group?: InstallationAddonGroup): IZipFetchInstallationProduct[] => {
  if (!group) {
    return [];
  }

  if (
    group.products.some(
      p => p.type !== InstallationProducType.Lawnmower && p.type !== InstallationProducType.Vvs
    )
  ) {
    return [];
  }

  return group.products as IZipFetchInstallationProduct[];
};
